import React, { useEffect, useState } from "react";
import Layout from "../../Components/Layout";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import toast from "react-hot-toast";
import { ToWords } from "to-words";

const toWords = new ToWords({
  localeCode: "en-IN",
  converterOptions: {
    currency: false,
    ignoreDecimal: true,
  },
});

const InvoiceCreate = () => {
  const [orderList, setOrderList] = useState([]);
  const [errors, setErrors] = useState({});
  const location = useLocation();
  const [originalInvoiceData, setOriginalInvoiceData] = useState(null);
  const isEdit = location.state?.isEdit || false;

  const invoiceId = location.state?.invoiceId || null;

  const [invoiceData, setInvoiceData] = useState({
    // invoiceNo: '',
    po: "",
    date: "",
    companyFor: "",
    billTo: "",
    shipTo: "",
    contactPerson: "",
    orderId: "",
    organizationName: "",
    gstNumber: "",
    gstType: "",
    cgst: 0,
    sgst: 0,
    igst: 0,
    paymentStatus: "",
    amountInWords: "",

    items: [
      {
        description: "",
        sac: "",
        price: "",
      },
    ],
  });

  const fetchInvoiceById = async () => {
    try {
      const token = localStorage.getItem("token");

      const response = await axios.get(
        `${process.env.REACT_APP_BACKEND_URL}/invoices/${invoiceId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );

      const invoice = response.data;
      const orderResponse = await axios.get(
        `${process.env.REACT_APP_BACKEND_URL}/orders/${invoice.orderId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );

      const order = orderResponse.data;

      const loadedData = {
        orderId: invoice.orderId || "",
        date: invoice.date || "",
        companyFor: invoice.companyFor || "",
        billTo: invoice.billTo || "",
        shipTo: invoice.shipTo || "",
        contactPerson: invoice.contactPerson || "",
        paymentStatus: invoice.paymentStatus || "",
        amountInWords: invoice.amountInWords || "",
        organizationName: order.organizationName || "",
        gstType: order.gstType || "",
        items: invoice.items || [],
        cgst: invoice.cgst || 0,
        sgst: invoice.sgst || 0,
        igst: invoice.igst || 0,
      };

      setInvoiceData(loadedData);
      setOriginalInvoiceData(loadedData);
    } catch (error) {
      console.log(error);

      toast.error("Failed To Fetch Invoice");
    }
  };

  // ================= VALIDATION FUNCTION =================
  const validateForm = () => {
    const newErrors = {};

    // Order Selection Validation
    if (!invoiceData.orderId || invoiceData.orderId === "") {
      newErrors.orderId = "Please select an order";
    }

    // Date Validation
    if (!invoiceData.date || invoiceData.date.trim() === "") {
      newErrors.date = "Date is required";
    }

    // Company For Validation
    if (!invoiceData.companyFor || invoiceData.companyFor.trim() === "") {
      newErrors.companyFor = "For  is required";
    }

    // Bill To Validation
    if (!invoiceData.billTo || invoiceData.billTo.trim() === "") {
      newErrors.billTo = "Bill To address is required";
    }

    // Ship To Validation
    if (!invoiceData.shipTo || invoiceData.shipTo.trim() === "") {
      newErrors.shipTo = "Ship To address is required";
    }

    /* Contact Person Validation
        if (!invoiceData.contactPerson || invoiceData.contactPerson.trim() === "") {
            newErrors.contactPerson = "Contact person is required";
        }

        */

    // Items Validation
    if (invoiceData.items && invoiceData.items.length > 0) {
      invoiceData.items.forEach((item, index) => {
        if (!item.description || item.description.trim() === "") {
          newErrors[`description_${index}`] = "Description is required";
        }
        if (!item.sac || item.sac.trim() === "") {
          newErrors[`sac_${index}`] = "SAC code is required";
        }
        if (!item.price || item.price <= 0) {
          newErrors[`price_${index}`] = "Valid price is required";
        }
      });
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const fetchOrders = async () => {
    try {
      const token = localStorage.getItem("token");

      const response = await axios.get(
        `${process.env.REACT_APP_BACKEND_URL}/orders?page=0&size=100`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );

      setOrderList(response.data.content);
    } catch (error) {
      console.error(error);
      toast.error("Failed To Fetch Orders");
    }
  };

  useEffect(() => {
    fetchOrders();

    if (isEdit && invoiceId) {
      fetchInvoiceById();
    }
  }, []);

  // Main Input Change
  const handleChange = (e) => {
    const { name, value } = e.target;

    setInvoiceData({
      ...invoiceData,
      [name]: value,
    });
    // Clear error for this field when user starts typing
    if (errors[name]) {
      setErrors({ ...errors, [name]: "" });
    }
  };

  const handleItemChange = (index, field, value) => {
    const updatedItems = [...invoiceData.items];

    updatedItems[index][field] = value;

    const subtotal = updatedItems.reduce(
      (acc, item) => acc + Number(item.price || 0),
      0,
    );

    let cgst = 0;
    let sgst = 0;
    let igst = 0;

    if (invoiceData.gstType === "INTER_STATE") {
      igst = subtotal * 0.18;
    } else if (invoiceData.gstType) {
      cgst = subtotal * 0.09;
      sgst = subtotal * 0.09;
    }

    const total = subtotal + cgst + sgst + igst;

    setInvoiceData({
      ...invoiceData,
      items: updatedItems,
      amountInWords:
        total > 0 ? `${toWords.convert(Math.round(total))} Rupees Only` : "",
    });
    // Clear error for this field
    if (errors[`${field}_${index}`]) {
      setErrors({ ...errors, [`${field}_${index}`]: "" });
    }
  };
  // Add Row
  const addMoreRow = () => {
    setInvoiceData({
      ...invoiceData,
      items: [
        ...invoiceData.items,
        {
          description: "",
          sac: "",
          price: "",
        },
      ],
    });
  };

  // Remove Row
  const removeRow = (index) => {
    if (invoiceData.items.length === 1) {
      toast.error("At least one item is required"); // ADD THIS
      return; // ADD THIS
    }

    const updatedItems = invoiceData.items.filter((_, i) => i !== index);

    setInvoiceData({
      ...invoiceData,
      items: updatedItems,
    });
  };

  const subtotal = invoiceData.items.reduce(
    (acc, item) => acc + Number(item.price || 0),
    0,
  );

  let cgst = 0;
  let sgst = 0;
  let igst = 0;

  if (invoiceData.gstType === "INTER_STATE") {
    igst = subtotal * 0.18;
  } else if (invoiceData.gstType) {
    cgst = subtotal * 0.09;
    sgst = subtotal * 0.09;
  }

  const total = subtotal + cgst + sgst + igst;

  const navigate = useNavigate();

  const handleCreateInvoice = async () => {
    // ADD THIS VALIDATION CHECK
    if (!validateForm()) {
      toast.error("Please fill all required fields correctly");
      return;
    }

    try {
      const token = localStorage.getItem("token");

      const finalInvoiceData = {
        orderId: Number(invoiceData.orderId),

        date: invoiceData.date,
        companyFor: invoiceData.companyFor,
        billTo: invoiceData.billTo,
        shipTo: invoiceData.shipTo,

        paymentStatus: invoiceData.paymentStatus,

        contactPerson: invoiceData.contactPerson,

        amountInWords: invoiceData.amountInWords,

        subtotal: Number(subtotal.toFixed(2)),

        total: Number(total.toFixed(2)),

        cgst: Number(cgst.toFixed(2)),
        sgst: Number(sgst.toFixed(2)),
        igst: Number(igst.toFixed(2)),

        items: invoiceData.items,
      };
      console.log("Invoice Payload => ", finalInvoiceData);

      if (isEdit) {
        const finalInvoiceData = {
          orderId: Number(invoiceData.orderId),
          date: invoiceData.date,
          companyFor: invoiceData.companyFor,
          billTo: invoiceData.billTo,
          shipTo: invoiceData.shipTo,
          paymentStatus: invoiceData.paymentStatus,
          contactPerson: invoiceData.contactPerson,
          amountInWords: invoiceData.amountInWords,
          subtotal: Number(subtotal.toFixed(2)),
          total: Number(total.toFixed(2)),
          cgst: Number(cgst.toFixed(2)),
          sgst: Number(sgst.toFixed(2)),
          igst: Number(igst.toFixed(2)),
          items: invoiceData.items,
        };

        const changedFields = getChangedFields(
          {
            ...originalInvoiceData,
            subtotal: Number(subtotal.toFixed(2)),
            total: Number(total.toFixed(2)),
          },
          finalInvoiceData,
        );

        if (Object.keys(changedFields).length === 0) {
          toast.error("No changes detected");
          return;
        }

        console.log("Changed Fields =>", changedFields);

        await axios.patch(
          `${process.env.REACT_APP_BACKEND_URL}/invoices/${invoiceId}`,
          changedFields,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
          },
        );

        toast.success("Invoice Updated Successfully");
      } else {
        await axios.post(
          `${process.env.REACT_APP_BACKEND_URL}/invoices`,
          finalInvoiceData,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
          },
        );

        toast.success("Invoice Created Successfully");
      }

      navigate("/list-invoice");
    } catch (error) {
      console.error("Create Invoice Error => ", error);

      console.log(error.response);
      // CHECK FOR BACKEND ERROR MESSAGE
      if (
        error.response &&
        error.response.data &&
        error.response.data.message
      ) {
        // Show the specific backend error message
        toast.error(error.response.data.message);
      } else if (error.response && error.response.status === 500) {
        // Generic 500 error message
        toast.error("Server error. Please try again later.");
      } else {
        // Default error message
        toast.error(
          isEdit ? "Failed To Update Invoice" : "Failed To Create Invoice",
        );
      }
    }
  };

  const handleOrderSelect = async (e) => {
    // Clear error when user selects
    if (errors.orderId) {
      setErrors({ ...errors, orderId: "" });
    }

    const orderId = e.target.value;

    try {
      const token = localStorage.getItem("token");

      const response = await axios.get(
        `${process.env.REACT_APP_BACKEND_URL}/orders/${orderId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );

      const order = response.data;

      const address = [
        order.address?.streetLine1,
        order.address?.streetLine2,
        order.address?.city,
        order.address?.state,
        order.address?.country,
        order.address?.postalCode,
      ]
        .filter(Boolean)
        .join(", ");

      setInvoiceData((prev) => ({
        ...prev,

        orderId: order.orderId,
        billTo: address,
        contactPerson: order.mobileNumber,
        organizationName: order.organizationName,
        gstNumber: order.gstNumber,

        gstType: order.gstType,
      }));
    } catch (error) {
      console.log(error);

      toast.error("Failed To Fetch Order");
    }
  };
  const getChangedFields = (original, updated) => {
    const changes = {};

    Object.keys(updated).forEach((key) => {
      const oldValue = original[key];
      const newValue = updated[key];

      if (JSON.stringify(oldValue) !== JSON.stringify(newValue)) {
        changes[key] = newValue;
      }
    });

    return changes;
  };
  return (
    <Layout>
      <div className="backgound-main-content py-4">
        <div className="container-fluid">
          <button className="btn btn-primary" onClick={() => navigate(-1)}>
            Back
          </button>

          <div
            className="bg-white border p-3 mt-2"
            style={{
              maxWidth: "1100px",
              margin: "0 auto",
            }}
          >
            {/* Header */}
            <div className="text-center border-bottom pb-2">
              <h2 className="fw-bold mb-1">RAK SOFTECH PRIVATE LTD</h2>

              <p className="mb-0">
                Office no 3, 3rd floor, Mayuri plaza, above SBI, Near Bhoir
                Hospital, Dange Chowk, Chinchwad Pune 411033
              </p>

              <p className="mb-0">
                email: kavitay@raksoftech.com | Ph: 91-9588614798
              </p>
            </div>

            {/* GST */}
            <div className="row border border-top-0 m-0">
              <div className="col-md-6 border-end py-2 fw-bold">
                GSTIN - 27AAHCR9750J1ZS
              </div>

              <div className="col-md-6 py-2 text-center fw-bold">
                GST INVOICE
              </div>
            </div>

            {/* Invoice Details */}
            <div className="row border border-top-0 m-0">
              <div className="col-md-6 py-2">
                {/*
                                <div className="mb-2">
                                    <label className="fw-bold">
                                        Invoice No
                                    </label>

                                    <input
                                        type="text"
                                        className="form-control"
                                        name="invoiceNo"
                                        value={invoiceData.invoiceNo}
                                        onChange={handleChange}
                                    />
                                </div>
                                */}

                <div className="col-md-6">
                  <label className="fw-bold">
                    Order Id <span className="text-danger">*</span>
                  </label>
                  <select
                    className={`form-select ${errors.orderId ? "is-invalid" : ""}`}
                    name="orderId"
                    value={invoiceData.orderId}
                    onChange={handleOrderSelect}
                  >
                    <option value="">Select Order</option>
                    {orderList.map((order) => (
                      <option key={order.orderId} value={order.orderId}>
                        {order.orderId}
                      </option>
                    ))}
                  </select>
                  {errors.orderId && (
                    <div className="invalid-feedback">{errors.orderId}</div>
                  )}
                </div>

                <div className="row mt-2">
                  <div className="mt-2">
                    <label className="fw-bold">Organization Name</label>

                    <input
                      type="text"
                      className="form-control"
                      name="organizationName"
                      value={invoiceData.organizationName}
                    />
                  </div>

                  {/* Payment Status */}
                  {isEdit && (
                    <div className="col-md-6">
                      <label className="fw-bold">Payment Status</label>

                      <select
                        className="form-select"
                        name="paymentStatus"
                        value={invoiceData.paymentStatus}
                        onChange={handleChange}
                      >
                        <option value="">Select Payment Status</option>

                        <option value="PAID">Paid</option>

                        <option value="PENDING">Pending</option>
                      </select>
                    </div>
                  )}
                </div>
              </div>

              <div className="col-md-6 py-2">
                <div className="mb-2">
                  <label className="fw-bold">
                    Date <span className="text-danger">*</span>
                  </label>
                  <input
                    type="date"
                    className={`form-control ${errors.date ? "is-invalid" : ""}`}
                    name="date"
                    value={invoiceData.date}
                    onChange={handleChange}
                  />
                  {errors.date && (
                    <div className="invalid-feedback">{errors.date}</div>
                  )}
                </div>

                <div>
                  <label className="fw-bold">
                    FOR <span className="text-danger">*</span>
                  </label>
                  <input
                    type="text"
                    className={`form-control ${errors.companyFor ? "is-invalid" : ""}`}
                    name="companyFor"
                    value={invoiceData.companyFor}
                    onChange={handleChange}
                  />
                  {errors.companyFor && (
                    <div className="invalid-feedback">{errors.companyFor}</div>
                  )}
                </div>
              </div>
            </div>

            {/* Address */}
            <div className="row border border-top-0 m-0">
              <div className="col-md-6 border-end py-2">
                <label className="fw-bold">Bill To</label>

                <textarea
                  rows="4"
                  className="form-control"
                  name="billTo"
                  value={invoiceData.billTo}
                  onChange={handleChange}
                />
              </div>

              <div className="col-md-6 py-2">
                <label className="fw-bold">
                  Ship To <span className="text-danger">*</span>
                </label>
                <textarea
                  rows="2"
                  className={`form-control mb-2 ${errors.shipTo ? "is-invalid" : ""}`}
                  name="shipTo"
                  value={invoiceData.shipTo}
                  onChange={handleChange}
                />
                {errors.shipTo && (
                  <div className="invalid-feedback">{errors.shipTo}</div>
                )}

                <label className="fw-bold">
                  Contact Person <span className="text-danger">*</span>
                </label>
                <input
                  type="text"
                  className="form-control"
                  name="contactPerson"
                  value={invoiceData.contactPerson}
                  onChange={handleChange}
                />
              </div>
            </div>

            {/* Table */}
            <div className="table-responsive">
              <table
                className="table table-bordered mb-0"
                style={{
                  tableLayout: "fixed",
                  width: "100%",
                }}
              >
                <thead>
                  <tr>
                    <th style={{ width: "45%" }}>
                      DESCRIPTION <span className="text-danger">*</span>
                    </th>
                    <th style={{ width: "20%" }}>
                      SAC <span className="text-danger">*</span>
                    </th>
                    <th style={{ width: "20%" }}>
                      AMOUNT <span className="text-danger">*</span>
                    </th>
                    <th style={{ width: "15%" }}>ACTION</th>
                  </tr>
                </thead>

                <tbody>
                  {invoiceData.items.map((item, index) => (
                    <tr key={index}>
                      <td>
                        <textarea
                          rows="2"
                          className={`form-control ${errors[`description_${index}`] ? "is-invalid" : ""}`}
                          value={item.description}
                          onChange={(e) =>
                            handleItemChange(
                              index,
                              "description",
                              e.target.value,
                            )
                          }
                        />
                        {errors[`description_${index}`] && (
                          <div className="invalid-feedback">
                            {errors[`description_${index}`]}
                          </div>
                        )}
                      </td>
                      <td>
                        <input
                          type="text"
                          className={`form-control ${errors[`sac_${index}`] ? "is-invalid" : ""}`}
                          value={item.sac}
                          onChange={(e) =>
                            handleItemChange(index, "sac", e.target.value)
                          }
                        />
                        {errors[`sac_${index}`] && (
                          <div className="invalid-feedback">
                            {errors[`sac_${index}`]}
                          </div>
                        )}
                      </td>
                      <td>
                        <input
                          className={`form-control ${errors[`price_${index}`] ? "is-invalid" : ""}`}
                          value={item.price}
                          onChange={(e) =>
                            handleItemChange(index, "price", e.target.value)
                          }
                        />
                        {errors[`price_${index}`] && (
                          <div className="invalid-feedback">
                            {errors[`price_${index}`]}
                          </div>
                        )}
                      </td>
                      <td className="text-center">
                        <button
                          type="button"
                          className="btn btn-danger btn-sm"
                          onClick={() => removeRow(index)}
                        >
                          Remove
                        </button>
                      </td>
                    </tr>
                  ))}
                  {/* Totals */}
                  {invoiceData.gstType === "INTER_STATE" ? (
                    <tr>
                      <td colSpan="2" className="text-end fw-bold">
                        IGST
                      </td>

                      <td colSpan="2">₹ {igst.toFixed(2)}</td>
                    </tr>
                  ) : (
                    <>
                      <tr>
                        <td colSpan="2" className="text-end fw-bold">
                          CGST
                        </td>

                        <td colSpan="2">₹ {cgst.toFixed(2)}</td>
                      </tr>

                      <tr>
                        <td colSpan="2" className="text-end fw-bold">
                          SGST
                        </td>

                        <td colSpan="2">₹ {sgst.toFixed(2)}</td>
                      </tr>
                    </>
                  )}

                  <tr>
                    <td colSpan="2" className="text-end fw-bold">
                      TOTAL
                    </td>

                    <td colSpan="2" className="fw-bold">
                      ₹ {total.toFixed(2)}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            {/* Add More */}
            <div className="mt-3">
              <button
                type="button"
                className="btn btn-primary"
                onClick={addMoreRow}
              >
                Add More
              </button>
            </div>

            {/* Amount In Words */}
            <div className="border p-3 mt-3">
              <label className="fw-bold">Amount In Words</label>

              <textarea
                rows="3"
                className="form-control"
                name="amountInWords"
                value={invoiceData.amountInWords}
                readOnly
              />
            </div>

            <div className="mt-3 mb-3">
              {/* Create Invoice */}
              <button
                type="button"
                className="btn btn-success"
                onClick={handleCreateInvoice}
              >
                {isEdit ? "Update Invoice" : "Create Invoice"}
              </button>
            </div>

            {/* Footer */}
            <div className="text-center fw-bold border p-2">
              THANK YOU FOR YOUR BUSINESS!
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default InvoiceCreate;
